import { researchGroup } from '@stereoagency/sanity-schema';
import {
  departmentProfilesQuery,
  groupLeaderQuery,
  relatedArticlesQuery,
  relatedJobsQuery,
  relatedProjectsQuery,
  taxonomiesQuery
} from '../groupOrPlatformSubqueries';

const groupPickFields = [
  '_id' as const,
  'slug' as const,
  'title' as const,
  'introduction' as const,
  'badges' as const,
  'aboutContent' as const,
  'researchContent' as const,
  'bioContent' as const,
  'teamContent' as const,
  'departments' as const
];

const filter =
  'select(defined($slug) => slug.current == $slug, defined($id) => _id == $id, false)';
export const researchGroupPageQuery = researchGroup.schema.builder
  .filter(filter)
  .pick(groupPickFields)
  .subquery({
    taxonomies: taxonomiesQuery
  })
  .first()
  .use();

export const researchGroupRelatedProjectsQuery = researchGroup.schema.builder
  .filter(filter)
  .pick(['_id'])
  .subquery({
    projects: relatedProjectsQuery
  })
  .first()
  .use();

export const researchGroupRelatedArticlesQuery = researchGroup.schema.builder
  .filter(filter)
  .pick(['_id'])
  .subquery({
    articles: relatedArticlesQuery
  })
  .first()
  .use();

export const researchGroupRelatedJobsQuery = researchGroup.schema.builder
  .filter(filter)
  .pick(['_id'])
  .subquery({
    jobs: relatedJobsQuery
  })
  .first()
  .use();

export const researchGroupProfilesQuery = researchGroup.schema.builder
  .filter(filter)
  .subquery({
    researchGroupLeader: groupLeaderQuery,
    departmentProfiles: departmentProfilesQuery
  })
  .first()
  .use();
